<template>
    <div
        ref="scrollView"
        class="repository-manage-page"
        @click.capture="(e) => userInfoNew.first_approve ? '' : checkAuthentice(e)"
    >
        <!-- 最近上传页 -->
        <template v-if="curPageType === 'recentUpload'">
            <recentUpload
                @hideRecentUpload="pageChange('')"
                @addContent="handleUploadDialog(true)"
            />
        </template>
        <!-- 案例列表页 -->
        <template v-else-if="curPageType === 'caseList'">
            <caseList
                :doamin-option="doaminOption"
                @hideCaseList="pageChange('')"
                @addCase="handleUploadDialog(true, 'case')"
                @editCase="addCase"
                @removeSuccess="getData"
            />
        </template>
        <!-- 问答语料列表页 -->
        <template v-else-if="curPageType === 'quesList'">
            <quesList
                :doamin-option="doaminOption"
                @hideQaList="pageChange('')"
                @addQa="handleUploadDialog(true, 'question')"
                @showQaEdit="addQa"
                @removeSuccess="getData"
            />
        </template>
        <template v-else-if="curPageType === 'caseEdit'">
            <caseEdit
                :case-info="editCaseInfo"
                @hideCaseEdit="goBack"
                @toCaseList="pageChange('caseList')"
                @addCaseSuccess="getData"
            />
        </template>
        <template v-else-if="curPageType === 'quesEdit'">
            <quesEdit
                :qa-info="editQaInfo"
                :is-open-old-edit="isOpenOldEdit"
                @hideQuesEdit="goBack"
                @toQuesList="pageChange('quesList')"
                @submitSuccess="quesSubmitSuccess"
            />
        </template>
        <div v-else>
            <div class="header">
                <div class="title">
                    快速上传知识内容
                    <!-- eslint-disable -->
                    <div class="tip" ref="mainTitleTip">
                    <!-- eslint-disable -->
                        <img
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                        />
                    </div>
                    <veui-popover
                        target="mainTitleTip"
                    >
                        历史个人原创案例和问答内容已自动更新至您的律师智能体知识库中。
                    </veui-popover>
                </div>
                <div class="subtitle">
                    一键上传您专属的案例内容、问答语料以及文章访谈等知识内容，提升智能体专业度，更快为您获取更多高价值用户~
                </div>
                <!-- <div class="btn" @click="pageChange('recentUpload')">查看最近上传的内容</div> -->
            </div>
            <div v-if="showTips || showSecondTips" class="tips">
                <veui-alert
                    v-if="showTips"
                    class="alert"
                    status="success"
                    ui="strong"
                >
                    已自动将您在律临后台的历史优质知识内容同步到知识库，您可以在当前页面进行查看与管理
                    <template #extra>
                        <veui-button ui="text" @click="closeTips('showTips')">
                            我知道了
                        </veui-button>
                    </template>
                </veui-alert>
                <veui-alert
                    v-if="showSecondTips"
                    class="alert alert-second"
                    status="success"
                    ui="strong"
                >
                    已为您提交导入您的全网优质问答申请，预计将于1个工作日后完成导入，届时您可以在当前页面问答语料模块查看全部导入内容。
                    <template #extra>
                        <veui-button ui="text" @click="closeTips('showSecondTips')">
                            我知道了
                        </veui-button>
                    </template>
                </veui-alert>
            </div>
            <div class="content" :class="{'content-not-tips': !(showTips || showSecondTips)}">
                <!-- 案例内容 -->
                <div class="box case-box">
                    <div class="box-header">
                        <div class="header-title">案例内容</div>
                        <div class="more-btn" @click="pageChange('caseList')">
                            {{caseInfo.knowledge_apply_count === 0 && caseInfo.case_count === 0 ? '去上传' : '查看全部'}}
                        </div>
                    </div>
                    <!-- 待修改 -->
                    <div v-if="caseInfo.knowledge_apply_count !== 0 || caseInfo.case_count !== 0">
                        <div class="box-item">
                            <div class="box-item-name">
                                知识库应用
                            </div>
                            <div class="box-item-value">{{ caseInfo.knowledge_apply_count }}</div>
                            <div v-if="caseInfo.daily_add" class="new">今日新增<span>{{ caseInfo.daily_add }}</span>个</div>
                        </div>
                        <div class="box-item">
                            <div class="box-item-name">个人原创</div>
                            <div class="box-item-value">{{ caseInfo.case_count }}</div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="no-content">暂时没有上传相关内容</div>
                        <div class="add-content">
                            <span class="add-btn" @click="pageChange('caseList')">上传案例内容，</span>
                            <span>提升律师智能体专业度</span>
                        </div>
                    </div>
                </div>
                <!-- 问答语料 -->
                <div class="box case-box">
                    <div class="box-header">
                        <div class="header-title">问答语料</div>
                        <div class="more-btn" @click="pageChange('quesList')">
                            {{qaInfo.qa_apply_count === 0 && qaInfo.qa_count === 0 ? '去上传' : '查看全部'}}
                        </div>
                    </div>
                    <!-- 待修改 -->
                    <div v-if="qaInfo.qa_apply_count !== 0 || qaInfo.qa_count !== 0">
                        <div class="box-item">
                            <div class="box-item-name">知识库应用</div>
                            <div class="box-item-value">{{ qaInfo.qa_apply_count }}</div>
                            <div class="new" v-if="qaInfo.qa_add">今日新增<span>{{ qaInfo.qa_add }}</span>个</div>
                        </div>
                        <div class="box-item">
                            <div class="box-item-name">个人原创</div>
                            <div class="box-item-value">{{ qaInfo.qa_count }}</div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="no-content">暂时没有上传相关内容</div>
                        <div class="add-content">
                            <span class="add-btn" @click="pageChange('quesList')">上传问答语料，</span>
                            <span>提升律师智能体专业度</span>
                        </div>
                    </div>
                </div>
                <!-- 文章访谈 -->
                <div class="box case-box">
                    <div class="box-header">
                        <div class="header-title">文章访谈</div>
                    </div>
                    <div class="not-online">
                            准备上线中，敬请期待~
                    </div>
                </div>
            </div>
            <div class="file-upload-box">
                <div class="file-upload-title">快速上传知识内容</div>
                <div class="tabs">
                    <div
                        :class="['tab-item', selectTab === 0 ? 'active' : '']"
                        @click="changeTab(0)"
                    >推荐问题</div>
                    <div
                        :class="['tab-item', selectTab === 1 ? 'active' : '']"
                        @click="changeTab(1)"
                    >文本上传</div>
                </div>
                <recommendList
                    v-if="selectTab === 0"
                    :list="questionList"
                    @answer="handleAnswer"
                />
                <fileUpload
                    v-else
                    :is-show-title="false"
                    @addCase="addCase"
                    @addQa="addQa"
                    @showRecentUpload="pageChange('recentUpload')"
                />
            </div>
        </div>
        <uploadDialog
            :show="showUploadDialog"
            :type="uploadType"
            @addCase="addCase"
            @addQa="addQa"
            @closeUploadDialog="handleUploadDialog(false)"
        />
    </div>
</template>

<script>
/**
 * @author dingzhenyue
 * @desc 知识库管理
 */

import {Popover, Alert, Button} from 'veui';
import fileUpload from '../components/fileUpload.vue';
import recentUpload from '../components/recentUpload.vue';
import caseList from '../components/caseList.vue';
import caseEdit from '../components/caseEdit.vue';
import uploadDialog from '../components/uploadDialog.vue';
import quesList from '../components/quesList.vue';
import quesEdit from '../components/quesEdit.vue';
import mixinauthentice from '@/mixins/authentice';
import {mapState} from 'vuex';
import recommendList from '../components/recommendList.vue';

export default {
    name: 'repositoryManage',
    mixins: [mixinauthentice],
    components: {
        'veui-popover': Popover,
        'veui-alert': Alert,
        'veui-button': Button,
        fileUpload,
        recentUpload,
        caseList,
        caseEdit,
        uploadDialog,
        quesList,
        quesEdit,
        recommendList
    },
    data() {
        return {
            curPageType: '', // recentUpload:最近上传
            isShowCase: false, // 是否展示案例列表
            doaminOption: [], // 擅长领域
            showUploadDialog: false, // 是否展示上传文件弹窗
            lastPage: '', // 上一个页面
            caseInfo: {}, // 案例的一些指标数据
            editCaseInfo: {}, // 编辑案例信息
            uploadType: '',
            editQaInfo: {}, // 当前编辑的问答内容
            qaInfo: {},
            showTips: false,
            showSecondTips: false,
            selectTab: 0, // 当前选择的tab
            pn: 1,
            rn: 100,
            questionList: [],
            isOpenOldEdit: false
        };
    },
    watch: {
        curPageType(val) {
            let list = ['recentUpload', 'caseList', '', 'quesList'];
            if (this.lastPage !== val && list.includes(val)) {
                this.lastPage = val;
            }
            localStorage.setItem('knowledgePage', val);
            if (val === 'quesEdit') {
                // 滑动到页面顶部
                this.$refs.scrollView && this.$refs.scrollView.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    },
    created() {
        this.$router.afterEach(to => {
            localStorage.setItem('knowledgePage', '');
        });
        this.getDomain();
        this.getData();
        this.getList();
        // 开始轮询
        this.startPolling();
        const {qid} = this.$route.query;
        if (qid) {
            this.getQuesByQid(qid);
        }
    },
    computed: {
        ...mapState({
            userInfoNew: state => state?.lawStore?.userInfoNew
        })
    },
    mounted() {
        let pageType = localStorage.getItem('knowledgePage') || '';
        const {anchor} = this.$route.query;
        this.curPageType = pageType || anchor || '';
        const {fr} = this.$route.query || {};
        this.showTips = localStorage.getItem('isShowTips') !== '1';
        this.showSecondTips = fr === 'qwnr' && localStorage.getItem('isShowSecondTips') !== '1';
        this.showTips && this.$wywLog.send({
            serverId: 18708,
            area: 'repository-manage-tips',
            action: 'show'
        });
        this.showSecondTips && this.$wywLog.send({
            serverId: 18708,
            area: 'repository-manage-second-tips',
            action: 'show'
        });
    },
    beforeDestroy() {
        // 停止轮询
        this.stopPolling();
    },
    methods: {
        // 问答提交成功后刷新数据
        quesSubmitSuccess() {
            this.getData();
            this.getList();
        },
        closeTips(type = 'showTips') {
            const tipData = {
                showTips: {
                    name: 'showTips',
                    local: 'isShowTips',
                    area: 'repository-manage-tips-close'
                },
                showSecondTips: {
                    name: 'showSecondTips',
                    local: 'isShowSecondTips',
                    area: 'repository-manage-tips-second-close'
                }
            };
            localStorage.setItem(tipData[type].local, '1');
            this[tipData[type].name] = false;
            this.$wywLog.send({
                serverId: 18708,
                area: tipData[type].area,
                action: 'click'
            });
        },

        goBack() {
            this.curPageType = this.lastPage || '';
            this.editQaInfo = null;
        },

        // val为空即是首页
        pageChange(val) {
            this.curPageType = val;
        },

        /**
         * 获取擅长领域
         */

        getDomain() {
            this.$http.get('/bp/api/lawyer/getfaxingbaodomain', {
            }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.doaminOption = res.data;
                }
            });
        },
        // 添加案例
        addCase({caseInfo} = {}) {
            this.editCaseInfo = caseInfo || {};
            this.showUploadDialog = false;
            this.curPageType = 'caseEdit';
        },
        /**
         * 上传文件弹窗
         * @param {boolean} show 是否展示
         * @param {string} type 类型,不传的话就是两种都展示
         */
        handleUploadDialog(show, type) {
            this.showUploadDialog = show;
            this.uploadType = type || '';
        },
        // 添加问答语料
        addQa({qaInfo, isOpenOldEdit} = {}) {
            this.isOpenOldEdit = isOpenOldEdit || false;
            this.editQaInfo = qaInfo || {};
            this.showUploadDialog = false;
            this.curPageType = 'quesEdit';
        },

        /**
         * 获取指标数据
        */

        getData() {
            this.$http.get('/bp/knowledge/getknowledgecount').then(res => {
                if (res?.code !== '0' || !res?.data) {
                    return;
                }
                const {case_count, daily_add, knowledge_apply_count} = res.data?.case || {};
                const {qa_count, daily_add: qa_add, knowledge_apply_count: qa_apply_count} = res.data?.qa || {};
                this.caseInfo = {
                    case_count,
                    daily_add,
                    knowledge_apply_count
                };
                this.qaInfo = {
                    qa_count,
                    qa_add,
                    qa_apply_count
                };
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },
        startPolling() {
            // 每隔2min发起一次请求
            this.intervalId = setInterval(this.getData, 1000 * 60 * 2);
        },
        // 清除定时器
        stopPolling() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        changeTab(val) {
            if (val !== this.selectTab) {
                this.selectTab = val;
                this.$wywLog.send({
                    serverId: 19022,
                    area: 'tab_' + val,
                    action: 'click'
                });
            }
        },

        /**
         * 获取列表，列表总数由非认领满和认领满两部分拼接而成，拼接点之后的页数为另一个列表的查询
         */

        getList() {
            const {register_domains_v1} = this.userInfoNew?.lawyer_info || {};
            const params = {
                pn: this.pn,
                rn: this.rn,
                domain: register_domains_v1?.split('$')?.join(',') || '',
                list_type: 1
            };
            this.$http.get('/bp/api/content/aigclist', {
                params
            }).then(res => {
                if (+res.code === 0) {
                    this.questionList = res.data?.list?.filter(item => !item.knowledge_claimed) || [];
                }
            });
        },

        /**
         * 根据问题ID获取问题信息
         * @param {number} qid 问题ID
         * @param {boolean} isClickBtn 是否为点击按钮获取
         */

        getQuesByQid(qid, isClickBtn) {
            const params = {
                qid,
                origin: 'knowledge'
            };
            this.$http.get('/bp/api/content/answerRace', {
                params
            }).then(res => {
                if (+res.code !== 0) {
                    if (isClickBtn) {
                        this.$Message.info('该问题您已回答过了，看看其他问题吧');
                    }
                    return;
                }
                if (res.data) {
                    this.isOpenOldEdit = false;
                    this.curPageType = 'quesEdit';
                    this.editQaInfo = {
                        ...res.data,
                        banEditTitle: true,
                        showTips: true
                    };
                }
            });
        },
        handleAnswer({qaInfo}) {
            if (qaInfo?.qid) {
                this.getQuesByQid(qaInfo.qid, true);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.repository-manage-page {
    height: 396px;
    border-radius: 8px;
    background: #fff;

    .header {
        height: 374px;
        padding: 40px 43px;
        margin: 3px;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/header-bg.png") no-repeat center / 100% 100%;

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 36px;
            color: #000;
            line-height: 36px;
            text-align: left;

            .tip {
                display: inline-block;
                margin-left: -5px;
            }
        }

        .subtitle {
            margin-top: 24px;
            width: 325px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #848691;
            line-height: 24px;
        }

        .btn {
            margin-top: 34px;
            width: 204px;
            height: 44px;
            background: #05f;
            border-radius: 6px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
        }
    }

    .tips {
        margin-top: -75px;
        padding: 0 24px;

        .alert-second {
            margin-top: 15px;
        }

        /deep/ .veui-alert-success .veui-alert-icon {
            color: #00d154;
        }

        /deep/ .veui-alert {
            height: 50px;
            padding: 13px 20px 15px;
            box-sizing: border-box;
            color: #1e1f24;
            background: rgba(0, 209, 84, .12);
        }

        /deep/ .veui-alert-content {
            margin-right: 0;
        }

        /deep/ .veui-alert-content-extra {
            cursor: pointer;

            .veui-button {
                color: #848691;
            }
        }
    }

    .content {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        padding: 0 24px;

        .box {
            background: #fff;
            border-radius: 8px;
            border: 1px solid #f2f2f2;
            flex: 1;
            padding: 20px;
            box-shadow: 0 10px 30px 0 rgba(0, 0, 0, .05);

            &:not(:first-child) {
                margin-left: 24px;
            }

            .box-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .header-title {
                    font-family: PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #333;
                    line-height: 16px;
                    text-align: left;
                }

                .more-btn {
                    cursor: pointer;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #05f;
                    line-height: 16px;
                    text-align: right;
                    position: relative;
                    padding-right: 16px;

                    &::after {
                        content: "";
                        position: absolute;
                        width: 11px;
                        height: 6px;
                        margin-left: 6px;
                        transform: rotate(90deg);
                        top: 27%;
                        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/role-set/blue-arrow.png") no-repeat center / 100% 100%;
                    }
                }
            }

            .not-online {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #848691;
                line-height: 14px;
                margin-top: 24px;
            }

            .box-item {
                display: flex;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #848691;
                line-height: 22px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                align-items: center;

                &:not(:first-child) {
                    margin-top: 14px;
                    line-height: 14px;
                }

                .box-item-name {
                    width: 78px;
                }

                .box-item-value {
                    color: #1e1f24;
                    font-weight: 500;
                    font-family: baidu number;
                }

                .new {
                    height: 22px;
                    margin-left: 10px;
                    display: inline-block;
                    background: rgba(0, 85, 255, .08);
                    border-radius: 20px;
                    padding: 4px 8px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #05f;
                    line-height: 14px;
                    text-align: left;

                    span {
                        font-family: baidu number;
                        font-weight: 500;
                    }
                }
            }

            .no-content {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #848691;
                line-height: 14px;
                text-align: left;
            }

            .add-content {
                margin-top: 14px;
                background: rgba(0, 85, 255, .08);
                border-radius: 20px;
                padding: 4px 8px;
                height: 22px;
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                line-height: 14px;
                text-align: left;
                color: rgba(51, 51, 51, 1);
                width: fit-content;

                .add-btn {
                    color: #05f;
                    cursor: pointer;
                }
            }
        }
    }

    .content-not-tips {
        margin-top: -75px;
    }

    .file-upload-box {
        background: #fff;
        padding: 84px 24px 24px;
        margin-top: -53px;

        .file-upload-title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            margin-bottom: 20px;
        }

        .tabs {
            display: flex;
            padding-bottom: 20px;
            border-bottom: 1px solid #e9ecf3;

            .tab-item {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #1e1f24;
                line-height: 16px;
                margin-right: 48px;
                cursor: pointer;

                &.active {
                    color: #05f;
                }
            }
        }
    }
}
</style>